import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrls: ['./token.component.css']
})
export class TokenComponent implements OnInit, OnDestroy {
  @Input() empleado: string;
  @Input() empleadoId: number;
  token: string;
  subscription: Subscription;
  interval;

  constructor(
    public activeModal: NgbActiveModal,
    private empleadoService: EmpleadosServicio
  ) { }

  ngOnInit() {
    this.generateToken();
    this.interval = setInterval(() => this.generateToken(), 3000);
  }

  private generateToken() {
    this.subscription = this.empleadoService.tokenCode(this.empleadoId).subscribe(token => {
      this.token = token;
      this.subscription.unsubscribe();
    }, () => this.subscription.unsubscribe());
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    clearInterval(this.interval);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/token/token.component.ts